<template>
  <div class="basic_wrap">
    <bsHeader title="提交订单" />
    <div class="page_content">
      <div v-if="hasPhysicalGoods" class="address_card" @click="showAddressPicker = true">
        <div class="address_left">
          <template v-if="selectedAddress">
            <p class="address_name">
              {{ selectedAddress.name }}
              <span>{{ selectedAddress.tel }}</span>
            </p>
            <p class="address_detail">{{ fullAddress(selectedAddress) }}</p>
          </template>
          <p v-else class="address_empty">请选择收货地址</p>
        </div>
        <div class="address_arrow"></div>
      </div>
      <div
        v-for="(group, groupIndex) in merchantGroups"
        :key="group.key"
        class="order_card"
      >
        <div class="store_row" @click="goMerchantShop(group)">
          <div class="store_name van-ellipsis">
            {{ group.merchant_name || '平台自营店' }}
          </div>
          <div class="store_arrow"></div>
        </div>
        <div
          v-for="item in group.items"
          :key="item.item_id"
          class="goods_row"
          @click="$router.push('/details/' + item.item_id)"
        >
          <img :src="item.img" alt="" class="goods_img" />
          <div class="goods_info">
            <p class="goods_title van-multi-ellipsis--l2">{{ item.title }}</p>
            <p class="goods_sku">默认</p>
            <p class="goods_price">¥{{ formatPrice(item.unit_price) }}</p>
          </div>
          <div class="goods_qty">x{{ item.number }}</div>
        </div>
        <div class="info_row">
          <span class="label">店铺优惠：</span>
          <span class="value muted">暂无优惠券</span>
        </div>
        <div v-if="groupIndex === 0" class="info_row input_row">
          <span class="label">买家留言</span>
          <input
            v-model.trim="data.buyer_remark"
            class="remark_input"
            type="text"
            maxlength="100"
            placeholder="选填买家留言"
          />
        </div>
      </div>
      <div class="summary_card">
        <div class="summary_row">
          <span>商品总价：</span>
          <span>¥{{ formatPrice(data.actual_money) }}</span>
        </div>
        <div class="summary_row">
          <span>平台优惠：</span>
          <span class="muted">暂无优惠券</span>
        </div>
      </div>
    </div>
    <div v-if="showAddressPicker" class="address_mask" @click="showAddressPicker = false">
      <div class="address_picker" @click.stop>
        <div class="picker_header">
          <span>选择收货地址</span>
          <span class="picker_add" @click="goAddAddress">+ 新增地址</span>
        </div>
        <div v-if="addressList.length" class="picker_list">
          <div
            v-for="addr in addressList"
            :key="addr.id"
            class="picker_item"
            :class="{ active: selectedAddress && selectedAddress.id === addr.id }"
            @click="selectAddress(addr)"
          >
            <div class="picker_info">
              <p class="picker_name">
                {{ addr.name }}
                <span>{{ addr.tel }}</span>
              </p>
              <p class="picker_detail">{{ fullAddress(addr) }}</p>
            </div>
            <div class="picker_radio"></div>
          </div>
        </div>
        <div v-else class="picker_empty">
          <p>还没有收货地址</p>
          <p class="picker_empty_tip">请先添加收货地址</p>
        </div>
      </div>
    </div>
    <div class="bottom_bar">
      <div class="bottom_total">
        合计：
        <span class="total_price">¥{{ formatPrice(data.actual_money) }}</span>
      </div>
      <div
        class="submit_btn"
        :class="submitDisabled ? 'disabled' : ''"
        @click="doPay"
      >
        {{ submitting ? '处理中...' : '立即下单' }}
      </div>
    </div>
  </div>
</template>

<script>
import Fetch from "../../utils/fetch";
import bsHeader from "../../components/bsHeader.vue";

export default {
  name: "Item",
  components: {
    bsHeader
  },
  data() {
    return {
      data: {
        item_list: [],
        user_money: 0,
        actual_money: 0,
        buyer_remark: ""
      },
      itemNum: 0,
      submitting: false,
      addressList: [],
      selectedAddress: null,
      showAddressPicker: false
    };
  },
  computed: {
    hasPhysicalGoods() {
      return this.data.item_list.some(item => parseInt(item.goods_type) === 0);
    },
    merchantGroups() {
      var map = {};
      var groups = [];
      this.data.item_list.forEach(item => {
        var key = String(item.merchant_id || ("item_" + item.item_id));
        if (!map[key]) {
          map[key] = {
            key: key,
            merchant_id: item.merchant_id || 0,
            merchant_name: item.merchant_name || "",
            merchant_logo: item.merchant_logo || "",
            items: []
          };
          groups.push(map[key]);
        }
        map[key].items.push(item);
      });
      return groups;
    },
    submitDisabled() {
      return this.submitting
        || !this.data.item_list.length
        || parseFloat(this.data.user_money) < parseFloat(this.data.actual_money);
    }
  },
  created() {
    this.$parent.footer("item", false);
  },
  mounted() {
    this.start();
  },
  methods: {
    formatPrice(value) {
      var num = parseFloat(value) || 0;
      return num.toFixed(2);
    },
    normalizeItem(detail, number) {
      var unitPrice = parseFloat(detail.price);
      if (isNaN(unitPrice) || unitPrice <= 0) {
        unitPrice = parseFloat(detail.min) || 0;
      }
      return {
        item_id: detail.id,
        title: detail.title,
        img: detail.img,
        stock: parseInt(detail.stock) || 0,
        num: parseInt(detail.num) || 0,
        merchant_id: parseInt(detail.merchant_id) || 0,
        merchant_name: detail.merchant_name || "",
        merchant_logo: detail.merchant_logo || "",
        goods_type: parseInt(detail.goods_type) || 0,
        unit_price: unitPrice,
        number: number
      };
    },
    recalcTotals() {
      var total = 0;
      var count = 0;
      this.data.item_list.forEach(item => {
        total += (parseFloat(item.unit_price) || 0) * (parseInt(item.number) || 0);
        count += parseInt(item.number) || 0;
      });
      this.data.actual_money = total.toFixed(2);
      this.itemNum = count;
    },
    saveCart() {
      var goodsList = this.data.item_list.map(item => {
        return {
          item_id: item.item_id,
          num: item.number
        };
      });
      localStorage.setItem("cart", JSON.stringify(goodsList));
    },
    savePayDraft() {
      var payload = {
        user_money: this.data.user_money,
        actual_money: this.data.actual_money,
        item_num: this.itemNum,
        buyer_remark: this.data.buyer_remark || "",
        item_list: this.data.item_list.map(item => {
          return {
            item_id: item.item_id,
            title: item.title,
            img: item.img,
            unit_price: item.unit_price,
            number: item.number,
            goods_type: parseInt(item.goods_type) || 0
          };
        })
      };
      if (this.hasPhysicalGoods) {
        payload.address = this.buildAddressPayload();
      }
      localStorage.setItem("shop_pay_confirm", JSON.stringify(payload));
    },
    buildAddressPayload() {
      if (!this.selectedAddress) return null;
      return {
        customer_name: this.selectedAddress.name || "",
        customer_tel: this.selectedAddress.tel || "",
        province: this.selectedAddress.province || "",
        city: this.selectedAddress.city || "",
        county: this.selectedAddress.county || "",
        address: this.selectedAddress.address || ""
      };
    },
    fullAddress(addr) {
      if (!addr) return "";
      return [
        addr.province || "",
        addr.city || "",
        addr.county || "",
        addr.address || ""
      ].filter(Boolean).join(" ");
    },
    loadAddressList() {
      return Fetch("/user/address").then(res => {
        var list = (res.data && res.data.list) || [];
        this.addressList = list;
        if (!this.selectedAddress && list.length) {
          this.selectedAddress = list[0];
        }
      }).catch(() => {
        this.addressList = [];
      });
    },
    selectAddress(addr) {
      this.selectedAddress = addr;
      this.showAddressPicker = false;
    },
    goAddAddress() {
      this.showAddressPicker = false;
      this.$router.push("/editaddress");
    },
    start() {
      var selectedGoodsJsonStr = localStorage.getItem("cart");
      if (!selectedGoodsJsonStr) {
        this.$toast("无效进入");
        this.$router.replace("/cart");
        return;
      }
      var selectedGoods = [];
      try {
        selectedGoods = JSON.parse(selectedGoodsJsonStr) || [];
      } catch (error) {
        selectedGoods = [];
      }
      if (!selectedGoods.length) {
        this.$toast("请先选择商品");
        this.$router.replace("/cart");
        return;
      }
      Promise.all([
        Fetch("/user/info"),
        Promise.all(
          selectedGoods.map(item =>
            Fetch("/shop/item_view", { id: item.item_id }).then(res =>
              this.normalizeItem(res.data, parseInt(item.num) || 1)
            )
          )
        )
      ]).then(res => {
        var userInfo = res[0].data || {};
        var itemList = res[1] || [];
        this.data.user_money = parseFloat(userInfo.money) || 0;
        this.data.item_list = itemList;
        this.saveCart();
        this.recalcTotals();
        this.loadAddressList();
      }).catch(() => {
        this.$toast("加载订单失败");
      });
    },
    goMerchantShop(group) {
      if (!group.merchant_id) {
        return;
      }
      this.$router.push({
        path: "/type",
        query: {
          merchant_id: group.merchant_id,
          type1: group.merchant_name || "品牌好店"
        }
      });
    },
    doPay() {
      if (this.submitDisabled) {
        if (parseFloat(this.data.user_money) < parseFloat(this.data.actual_money)) {
          this.$toast("余额不足，请先充值");
        }
        return;
      }
      if (!this.data.item_list.length) {
        this.$toast("暂无可提交商品");
        return;
      }
      if (parseFloat(this.data.user_money) < parseFloat(this.data.actual_money)) {
        this.$toast("余额不足，请先充值");
        return;
      }
      if (this.hasPhysicalGoods && !this.selectedAddress) {
        this.$toast("请先选择收货地址");
        this.showAddressPicker = true;
        return;
      }
      this.submitting = true;
      this.saveCart();
      this.savePayDraft();
      this.$router.push("/pay");
      this.submitting = false;
    }
  }
};
</script>

<style lang="less" scoped>
.basic_wrap {
  min-height: 100vh;
  background: #f5f5f5;
  margin-top: 64px;
  padding-bottom: 80px;
}

.page_content {
  padding: 0 10px;
}

.address_card {
  display: flex;
  align-items: center;
  background: #ffffff;
  border-radius: 10px;
  margin-bottom: 10px;
  padding: 14px 12px;
}

.address_left {
  flex: 1;
  min-width: 0;
}

.address_name {
  font-size: 15px;
  color: #333333;
  font-weight: 500;
}

.address_name span {
  margin-left: 10px;
  font-size: 13px;
  color: #999999;
  font-weight: normal;
}

.address_detail {
  margin-top: 6px;
  font-size: 13px;
  line-height: 19px;
  color: #666666;
  word-break: break-all;
}

.address_empty {
  font-size: 14px;
  color: #ff6a3d;
}

.address_arrow {
  width: 7px;
  height: 12px;
  margin-left: 8px;
  flex-shrink: 0;
  background: url(../images/item/more.png) no-repeat center center;
  background-size: 100% 100%;
}

.address_mask {
  position: fixed;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
  width: 100%;
  max-width: 500px;
  height: 100%;
  background: rgba(0, 0, 0, 0.45);
  z-index: 200;
}

.address_picker {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  max-height: 60%;
  overflow-y: auto;
  background: #ffffff;
  border-radius: 12px 12px 0 0;
  padding-bottom: 20px;
}

.picker_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 14px 10px;
  font-size: 16px;
  color: #333333;
  font-weight: 500;
}

.picker_add {
  font-size: 13px;
  color: #ff6a3d;
  font-weight: normal;
}

.picker_item {
  display: flex;
  align-items: center;
  padding: 12px 14px;
  border-top: 1px solid #f4f4f4;
}

.picker_info {
  flex: 1;
  min-width: 0;
}

.picker_name {
  font-size: 14px;
  color: #333333;
  font-weight: 500;
}

.picker_name span {
  margin-left: 10px;
  font-size: 12px;
  color: #999999;
  font-weight: normal;
}

.picker_detail {
  margin-top: 4px;
  font-size: 12px;
  line-height: 18px;
  color: #666666;
  word-break: break-all;
}

.picker_radio {
  width: 16px;
  height: 16px;
  margin-left: 10px;
  border-radius: 50%;
  border: 1px solid #d7d7d7;
  box-sizing: border-box;
  flex-shrink: 0;
}

.picker_item.active .picker_radio {
  border-color: #ff6a3d;
  background: #ff6a3d;
  box-shadow: inset 0 0 0 4px #ffffff;
}

.picker_empty {
  padding: 40px 0;
  text-align: center;
  font-size: 14px;
  color: #999999;
}

.picker_empty_tip {
  margin-top: 6px;
  font-size: 12px;
  color: #b3b3b3;
}

.order_card,
.summary_card {
  background: #ffffff;
  border-radius: 10px;
  margin-bottom: 10px;
  overflow: hidden;
}

.store_row,
.info_row,
.summary_row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.store_row {
  padding: 14px 12px;
  font-size: 15px;
  color: #333333;
}

.store_name {
  flex: 1;
  font-weight: 500;
}

.store_arrow {
  width: 7px;
  height: 12px;
  margin-left: 8px;
  background: url(../images/item/more.png) no-repeat center center;
  background-size: 100% 100%;
}

.goods_row {
  display: flex;
  align-items: flex-start;
  padding: 12px;
  border-top: 1px solid #f4f4f4;
}

.goods_img {
  width: 72px;
  height: 72px;
  border-radius: 8px;
  object-fit: cover;
  flex-shrink: 0;
  background: #f5f5f5;
}

.goods_info {
  flex: 1;
  min-width: 0;
  margin-left: 12px;
}

.goods_title {
  font-size: 14px;
  line-height: 20px;
  color: #333333;
}

.goods_sku {
  margin-top: 6px;
  font-size: 12px;
  color: #999999;
}

.goods_price {
  margin-top: 8px;
  font-size: 16px;
  color: #ff6a3d;
}

.goods_qty {
  margin-left: 12px;
  font-size: 13px;
  color: #999999;
}

.info_row,
.summary_row {
  min-height: 48px;
  padding: 0 12px;
  font-size: 14px;
  color: #333333;
  border-top: 1px solid #f4f4f4;
}

.label {
  color: #333333;
}

.value {
  max-width: 60%;
  text-align: right;
}

.muted {
  color: #b3b3b3;
}

.input_row {
  justify-content: flex-start;
}

.remark_input {
  flex: 1;
  min-width: 0;
  height: 40px;
  border: none;
  text-align: right;
  font-size: 14px;
  color: #333333;
  background: transparent;
}

.remark_input::placeholder {
  color: #b3b3b3;
}

.bottom_bar {
  position: fixed;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  width: 100%;
  max-width: 500px;
  height: 58px;
  padding: 0 12px;
  background: #ffffff;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.06);
  display: flex;
  align-items: center;
}

.bottom_total {
  font-size: 15px;
  color: #333333;
}

.total_price {
  color: #ff6a3d;
}

.submit_btn {
  width: 110px;
  height: 38px;
  line-height: 38px;
  margin-left: auto;
  text-align: center;
  border-radius: 19px;
  font-size: 15px;
  color: #ffffff;
  background: linear-gradient(90deg, #ff6a3d 0%, #ff7f3f 100%);
}

.submit_btn.disabled {
  background: #c9c9c9;
  pointer-events: none;
}
</style>
